import React, { useMemo, useState } from 'react';
import zynityLogo from '../../assets/images/zynity_logo.png';

export type AuthMenuItem = {
  label: string;
  href: string;
};

export const defaultAuthMenuItems: AuthMenuItem[] = [
  { label: 'Public Site', href: 'https://zynity.com/' },
  { label: 'Help Request', href: '/help-request' },
  { label: 'Login', href: '/site/login' },
  { label: 'Sign Up', href: '/people/register' },
];

type Props = {
  menuItems?: AuthMenuItem[];
};

export const AuthHeader: React.FC<Props> = ({ menuItems }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const resolvedMenuItems = useMemo(() => menuItems || defaultAuthMenuItems, [menuItems]);

  const toggleMenu = () => setIsMenuOpen((open) => !open);
  const handleLinkClick = () => setIsMenuOpen(false);

  return (
    <header className="login-navbar">
      <a className="navbar-logo" href="https://apps.zynity.com" aria-label="Zynity home">
        <img src={zynityLogo} alt="Zynity logo" />
      </a>
      <div className="navbar-menu">
        <button
          type="button"
          className="menu-button"
          aria-haspopup="true"
          aria-expanded={isMenuOpen}
          onClick={toggleMenu}
        >
          <span className="menu-icon" aria-hidden="true">
            &#9776;
          </span>
        </button>
        {isMenuOpen && (
          <div className="menu-dropdown">
            {resolvedMenuItems.map((item) => (
              <a key={item.label} className="menu-item" href={item.href} onClick={handleLinkClick}>
                {item.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};
